/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { RoomOptionsState } from '../state/RoomOptionsState'
import RoomEvent from '../../event/RoomEvent'

class RoomOptionsWithLoadingStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new RoomOptionsState()
  }

  reduce(state, action) {
    const payload = action.payload

    if (action.type === RoomEvent.fetchByUser) {
      const options = payload.houses.map(item => {
        return { value: item.id, label: item.name }
      })
      return state.merge({
        options: options,
        isLoading: false
      })
    }

    return state
  }
}

export default new RoomOptionsWithLoadingStore()
